import { memo as Memo, useEffect, useRef, useState, useCallback } from 'react';
import dayjs from 'dayjs';
import { gsap } from 'gsap';

//* HOC's
import withUIContext from '@context/consumerHOC/UIConsumer';

//* Components
import Text from '@components/global/Text';
import Image from '@components/global/Image';
import CustomLink from '@components/global/CustomLink';
import HTMLContainer from '@components/global/HTMLContainer';

//* Styles
import BlogListItemStyle from './style';

const BlogListItem = Memo(({ url, createdAtr, screenSizes, winWidth }) => {
	//! Refs
	const addToRefs = useRef();
	const addToRefs1 = useRef();
	const tl = useRef();
	const timeout = useRef();
	const clientHeight = useRef(0);
	const imageHeight = useRef(0);

	//! States
	const [act, setAct] = useState(false);

	useEffect(() => {
		if (winWidth >= screenSizes.screenM && addToRefs?.current) {
			clientHeight.current = addToRefs?.current?.clientHeight;
			imageHeight.current = addToRefs1?.current?.childNodes[0]?.children[0]?.clientHeight;
			gsap.to(addToRefs?.current, 0, { height: clientHeight.current });
		}
	}, [winWidth, screenSizes.screenM]);

	useEffect(() => {
		tl.current?.clear();
		tl.current = gsap
			.timeline({
				paused: true,
			})
			.to(addToRefs?.current, 0.3, { marginTop: (imageHeight.current - clientHeight.current) * -1, height: imageHeight.current }, 0);
	}, [winWidth]);

	useEffect(() => {
		if (winWidth >= screenSizes.screenM) {
			if (act) {
				tl.current.play();
			} else {
				tl.current.reverse();
			}
		}
	}, [act, winWidth, screenSizes.screenM]);

	//! Hover Start
	const HoverStart = useCallback(() => {
		timeout.current = setTimeout(() => setAct(true), 300);
	}, []);

	useEffect(() => {
		return () => {
			timeout.current && clearTimeout(timeout.current);
		};
	}, []);

	//! Hover End
	const HoverEnd = useCallback(() => {
		setAct(false);
	}, []);

	return (
		<BlogListItemStyle
			ref={addToRefs}
			className={`blogItem`}
			onMouseLeave={HoverEnd}
			onMouseEnter={HoverStart}>
			<CustomLink
				external
				url={url}
				disableCr>
				<HTMLContainer className={'blogCont'}>
					<div className={`crRead blogItemInfo`}>
						<div className={'blogItemDate'}>
							<Text className={`p-m font-anonymous font-bold createdAt`}>{dayjs(createdAtr.createdAt).format('DD/MM/YYYY')}</Text>
						</div>
						<Text
							uppercase
							className={`p-m font-poppins font-italic category`}>
							{createdAtr.category}
						</Text>

						<Text
							tag={'h5'}
							className={`font-poppins font-medium title`}>
							{createdAtr.title}
						</Text>

						<Text className={`p-m font-poppins font-light description`}>{createdAtr.introText}</Text>

						<div className={'readTimeWrap'}>
							<Text
								tag={'span'}
								className='p-m cs-book-reader'
							/>

							<Text className={`font-poppins font-regular readTime`}>{createdAtr.readTime} min. read</Text>
						</div>
					</div>

					<div
						ref={addToRefs1}
						className={'blogItemImage'}>
						<Image
							src={createdAtr.smallImage.fields.file.url}
							alt={createdAtr.smallImage.fields.title}
						/>
					</div>
				</HTMLContainer>
			</CustomLink>
		</BlogListItemStyle>
	);
});

export default withUIContext(BlogListItem, ['winWidth', 'screenSizes']);
